import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-rectangle-icon',
  templateUrl: './design-rectangle.component.html'
})
export class DesignRectangleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
